import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { LAB_TEST_REFERENCE_VALUES, isAbnormalResult } from "../../../../utils/constants/labTestReferenceValues";

const fields = [
  { key: "bilirubinT", label: "Bilirubin (T)", unit: "mg/dL" },
  { key: "bilirubinD", label: "Bilirubin (D)", unit: "mg/dL" },
  { key: "sgot_ast", label: "SGOT/AST", unit: "U/L" },
  { key: "albunmin", label: "Albumin", unit: "g/dL" },
];

export default function LiverFunctionTestReport({ defaultValues, gender, reportTemplate }) {
  if (!defaultValues || Object.keys(defaultValues).length === 0) {
    return <p>डाटा उपलब्ध छैन</p>;
  }
  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="Liver Function Test">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>Test</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Reference Value</TableCell>
            <TableCell>Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {fields.map(({ key, label, unit }) => (
            defaultValues[key] ? (
              <TableRow key={key}>
                <TableCell>{label}</TableCell>
                <TableCell style={isAbnormalResult(key, defaultValues[key], reportTemplate, gender) ? { fontWeight: "bold" } : {}}>
                  {defaultValues[key]}
                </TableCell>
                <TableCell>{LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key]?.reference || "-"}</TableCell>
                <TableCell>{unit}</TableCell>
              </TableRow>
            ) : null
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
